import DatePicker from "@/components/date-picker";

import { AppColors } from "@/styles/colors";
import { Box, Card, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { Control, FieldErrors, FieldValues } from "react-hook-form";
import { PriceBoardCurrencyField } from "./PriceBoardCurrencyField";

interface Props {
  control: Control<FieldValues>;
  errors: FieldErrors<FieldValues>;
  disableInputs?: boolean;
}

export const PriceBoardForm = ({ control, errors, disableInputs }: Props) => {
  return (
    <>
      <Box maxW="250px">
        <DatePicker
          control={control}
          errors={errors?.fecha}
          placeholder="Ingresar fecha"
          maxDate={dayjs()}
          disablePortal={false}
          labelText="Fecha"
          name="fecha"
          clearable={false}
        />
      </Box>
      {/* Formulario para datos de Mercado */}
      <Card.Root maxW="full" marginTop="20px" borderRadius="8px">
        <Card.Body
          paddingX="48px"
          paddingY="30px"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Text fontSize="18px" fontWeight={700} marginBottom="16px">
            Precio Mercado
          </Text>
          <Grid templateColumns="repeat(4, 1fr)">
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="sojaMercado"
                label="Soja"
                invalid={!!errors?.sojaMercado?.message}
                errorText={
                  typeof errors?.sojaMercado?.message === "string"
                    ? errors.sojaMercado.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="maizMercado"
                label="Maíz"
                invalid={!!errors?.maizMercado?.message}
                errorText={
                  typeof errors?.maizMercado?.message === "string"
                    ? errors.maizMercado.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="trigoMercado"
                label="Trigo"
                invalid={!!errors?.trigoMercado?.message}
                errorText={
                  typeof errors?.trigoMercado?.message === "string"
                    ? errors.trigoMercado.message
                    : ""
                }
              />
            </GridItem>
          </Grid>
        </Card.Body>
      </Card.Root>

      <Card.Root maxW="full" marginTop="20px" borderRadius="8px">
        <Card.Body
          paddingX="48px"
          paddingY="30px"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Text fontSize="18px" fontWeight={700} marginBottom="16px">
            Precio Unión
          </Text>
          <Grid templateColumns="repeat(4, 1fr)">
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="sojaUnion"
                label="Soja"
                invalid={!!errors?.sojaUnion?.message}
                errorText={
                  typeof errors?.sojaUnion?.message === "string"
                    ? errors.sojaUnion.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="maizUnion"
                label="Maíz"
                invalid={!!errors?.maizUnion?.message}
                errorText={
                  typeof errors?.maizUnion?.message === "string"
                    ? errors.maizUnion.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="trigoUnion"
                label="Trigo"
                invalid={!!errors?.trigoUnion?.message}
                errorText={
                  typeof errors?.trigoUnion?.message === "string"
                    ? errors.trigoUnion.message
                    : ""
                }
              />
            </GridItem>
          </Grid>
        </Card.Body>
      </Card.Root>

      {/* Formulario para datos de Insumos */}
      <Card.Root maxW="full" marginTop="20px" borderRadius="8px">
        <Card.Body
          paddingX="48px"
          paddingY="30px"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Text fontSize="18px" fontWeight={700} marginBottom="16px">
            Precio Insumos
          </Text>
          <Grid templateColumns="repeat(4, 1fr)">
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="sojaInsumos"
                label="Soja"
                invalid={!!errors?.sojaInsumos?.message}
                errorText={
                  typeof errors?.sojaInsumos?.message === "string"
                    ? errors.sojaInsumos.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="maizInsumos"
                label="Maiz"
                invalid={!!errors?.maizInsumos?.message}
                errorText={
                  typeof errors?.maizInsumos?.message === "string"
                    ? errors.maizInsumos.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="trigoInsumos"
                label="Trigo"
                invalid={!!errors?.trigoInsumos?.message}
                errorText={
                  typeof errors?.trigoInsumos?.message === "string"
                    ? errors.trigoInsumos.message
                    : ""
                }
              />
            </GridItem>
          </Grid>
        </Card.Body>
      </Card.Root>
      {/* Formulario para datos de Pizarra */}
      <Card.Root maxW="full" marginTop="30px" borderRadius="8px">
        <Card.Body
          paddingX="48px"
          paddingY="30px"
          borderRadius="8px"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Text fontSize="18px" fontWeight={700} marginBottom="16px">
            Precio Pizarra
          </Text>
          <Grid templateColumns="repeat(4, 1fr)">
            <GridItem paddingX="16px" paddingY="8px">
              <DatePicker
                control={control}
                errors={errors?.fechaPizarra}
                placeholder="Ingresar fecha"
                maxDate={dayjs()}
                disablePortal={false}
                labelText="Fecha de publicación"
                name="fechaPizarra"
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="sojaPizarra"
                label="Soja"
                invalid={!!errors?.sojaPizarra?.message}
                errorText={
                  typeof errors?.sojaPizarra?.message === "string"
                    ? errors.sojaPizarra.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="maizPizarra"
                label="Maíz"
                invalid={!!errors?.maizPizarra?.message}
                errorText={
                  typeof errors?.maizPizarra?.message === "string"
                    ? errors.maizPizarra.message
                    : ""
                }
              />
            </GridItem>
            <GridItem paddingX="16px" paddingY="8px">
              <PriceBoardCurrencyField
                disabled={disableInputs}
                control={control}
                fieldName="trigoPizarra"
                label="Trigo"
                invalid={!!errors?.trigoPizarra?.message}
                errorText={
                  typeof errors?.trigoPizarra?.message === "string"
                    ? errors.trigoPizarra.message
                    : ""
                }
              />
            </GridItem>
          </Grid>
        </Card.Body>
      </Card.Root>
    </>
  );
};
